export enum RotationType {
  FULL_DAY = 'FULL_DAY',
  DAY_NIGHT = 'DAY_NIGHT',
}
